import React from 'react';
import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const PineLabsPOS = dynamic(() => import("../../components/hardware-partners/PineLabs/DesktopPineLabs"), {
    loading: () => <Loading />,
}
);

const MobilePineLabsPOS = dynamic(() => import("../../components/hardware-partners/PineLabs/MobilePineLabs"), {
    loading: () => <Loading />,
}
);

const iminPosSystem = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>Pinelabs POS Machines Compatible With QueueBuster POS Software</title>
                <meta name="description" content="Pinelabs POS + QueueBuster POS = Effortless payments, faster checkouts & happy customers." />
                <link rel="canonical" href="https://queuebuster.co/pos-hardware-partners/pinelabs" />
                <link rel="alternate" href="https://queuebuster.co/pos-hardware-partners/pinelabs" hrefLang="en-us" />
                <meta property="og:title" content="Pinelabs POS Hardware Devices Compatible With QueueBuster POS Software" />
                <meta property="og:description" content="Pinelabs POS + QueueBuster POS = Effortless payments, faster checkouts & happy customers." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/pinelabs.jpg" />
                <meta property="og:url" content="https://queuebuster.co/pos-hardware-partners/pinelabs" />
                
            </Head>
            {mobileView ? <MobilePineLabsPOS /> : <PineLabsPOS />}
        </>
    )
}

export default iminPosSystem